import e, { Component as t } from "react";
function r(e, t) {
  return r = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  }, r(e, t);
}
var n = function n(e) {
    var t = document.createElement("script");
    t.async = !0, t.defer = !0, t.src = e, document.head && document.head.appendChild(t);
  },
  i = function i(e) {
    return Array.from(document.scripts).reduce(function (t, r) {
      return t || e.test(r.src);
    }, !1);
  },
  o = /(http|https):\/\/(www)?.+\/recaptcha/,
  a = ["sitekey", "theme", "size", "badge", "tabindex", "hl", "isolated"],
  c = /*#__PURE__*/function (t) {
    var c, s;
    function p() {
      for (var r, a = arguments.length, c = new Array(a), s = 0; s < a; s++) c[s] = arguments[s];
      return (r = t.call.apply(t, [this].concat(c)) || this).container = void 0, r.timer = void 0, r.state = {
        instanceKey: Date.now(),
        ready: !1,
        rendered: !1,
        invisible: "invisible" === r.props.size
      }, r._isAvailable = function () {
        var e;
        return Boolean(null == (e = window.grecaptcha) ? void 0 : e.ready);
      }, r._inject = function () {
        r.props.inject && !i(o) && n("https://recaptcha.net/recaptcha/api.js?render=explicit" + (r.props.hl ? "&hl=" + r.props.hl : ""));
      }, r._prepare = function () {
        var e = r.props,
          t = e.explicit,
          n = e.onLoad;
        window.grecaptcha.ready(function () {
          r.setState({
            ready: !0
          }, function () {
            t || r.renderExplicitly(), n && n();
          });
        });
      }, r._renderRecaptcha = function (e, t) {
        return window.grecaptcha.render(e, t);
      }, r._resetRecaptcha = function () {
        return window.grecaptcha.reset(r.state.instanceId);
      }, r._executeRecaptcha = function () {
        return window.grecaptcha.execute(r.state.instanceId);
      }, r._getResponseRecaptcha = function () {
        return window.grecaptcha.getResponse(r.state.instanceId);
      }, r._onVerify = function (e) {
        return r.props.onVerify(e);
      }, r._onExpire = function () {
        return r.props.onExpire && r.props.onExpire();
      }, r._onError = function () {
        return r.props.onError && r.props.onError();
      }, r._stopTimer = function () {
        r.timer && clearInterval(r.timer);
      }, r.componentDidMount = function () {
        r._inject(), r._isAvailable() ? r._prepare() : r.timer = window.setInterval(function () {
          r._isAvailable() && (r._prepare(), r._stopTimer());
        }, 500);
      }, r.componentWillUnmount = function () {
        r._stopTimer();
      }, r.renderExplicitly = function () {
        return new Promise(function (e, t) {
          if (r.state.rendered) return t(new Error("This recaptcha instance has been already rendered."));
          if (!r.state.ready || !r.container) return t(new Error("Recaptcha is not ready for rendering yet."));
          var n = r._renderRecaptcha(r.container, {
            sitekey: r.props.sitekey,
            theme: r.props.theme,
            size: r.props.size,
            badge: r.state.invisible ? r.props.badge : void 0,
            tabindex: r.props.tabindex,
            callback: r._onVerify,
            "expired-callback": r._onExpire,
            "error-callback": r._onError,
            isolated: r.state.invisible ? r.props.isolated : void 0,
            hl: r.state.invisible ? void 0 : r.props.hl
          });
          r.setState({
            instanceId: n,
            rendered: !0
          }, function () {
            r.props.onRender && r.props.onRender(), e();
          });
        });
      }, r.reset = function () {
        return new Promise(function (e, t) {
          if (r.state.rendered) return r._resetRecaptcha(), e();
          t(new Error("This recaptcha instance did not render yet."));
        });
      }, r.execute = function () {
        return new Promise(function (e, t) {
          return r.state.invisible ? (r.state.rendered && (r._executeRecaptcha(), e()), t(new Error("This recaptcha instance did not render yet."))) : t(new Error("Manual execution is only available for invisible size."));
        });
      }, r.getResponse = function () {
        return new Promise(function (e, t) {
          if (r.state.rendered) return e(r._getResponseRecaptcha());
          t(new Error("This recaptcha instance did not render yet."));
        });
      }, r.render = function () {
        var t = /*#__PURE__*/e.createElement("div", {
          key: r.state.instanceKey,
          id: r.props.id,
          className: r.props.className,
          ref: function ref(e) {
            return r.container = e;
          }
        });
        return r.props.children ? r.props.children({
          renderExplicitly: r.renderExplicitly,
          reset: r.reset,
          execute: r.execute,
          getResponse: r.getResponse,
          recaptchaComponent: t
        }) : t;
      }, r;
    }
    return s = t, (c = p).prototype = Object.create(s.prototype), c.prototype.constructor = c, r(c, s), p.getDerivedStateFromProps = function (e, t) {
      var r = "invisible" === e.size;
      return r !== t.invisible ? {
        invisible: r
      } : null;
    }, p.prototype.componentDidUpdate = function (e) {
      var t = this;
      a.reduce(function (r, n) {
        return t.props[n] !== e[n] ? [].concat(r, [n]) : r;
      }, []).length > 0 && this.setState({
        instanceKey: Date.now(),
        rendered: !1
      }, function () {
        t.props.explicit || t.renderExplicitly();
      });
    }, p;
  }(t);
c.defaultProps = {
  id: "",
  className: "g-recaptcha",
  theme: "light",
  size: "normal",
  badge: "bottomright",
  tabindex: 0,
  explicit: !1,
  inject: !0,
  isolated: !1,
  hl: ""
};
export { c as default };